import { useTranslation } from 'react-i18next'

const STEP_LABEL_KEYS = [
  'onboarding.steps.profile',
  'onboarding.steps.teacher',
  'onboarding.steps.interests',
  'onboarding.steps.done',
]

interface OnboardingProgressProps {
  currentStep: number
  totalSteps?: number
}

export function OnboardingProgress({ currentStep, totalSteps = 4 }: OnboardingProgressProps) {
  const { t } = useTranslation()

  return (
    <nav aria-label={t('onboarding.steps.nav_label')} className="flex items-start justify-center gap-0">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1
        const isCompleted = step < currentStep
        const isActive = step === currentStep

        return (
          <div key={step} className="flex items-start">
            <div className="flex flex-col items-center gap-1.5">
              <div
                aria-current={isActive ? 'step' : undefined}
                className={[
                  'flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors duration-200',
                  isCompleted
                    ? 'bg-mindeia-success text-white'
                    : isActive
                    ? 'bg-mindeia-primary text-white'
                    : 'bg-surface-200 text-neutral-600',
                ].join(' ')}
              >
                {isCompleted ? (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                    <path
                      d="M2 7l4 4 6-6"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  step
                )}
              </div>
              <span
                className={[
                  'text-xs font-medium',
                  isActive ? 'text-mindeia-primary' : 'text-neutral-600',
                ].join(' ')}
              >
                {t(STEP_LABEL_KEYS[i])}
              </span>
            </div>
            {step < totalSteps && (
              <div
                className={[
                  'mx-3 mt-4 h-0.5 w-14 flex-shrink-0 transition-colors duration-200',
                  isCompleted ? 'bg-mindeia-success' : 'bg-surface-200',
                ].join(' ')}
              />
            )}
          </div>
        )
      })}
    </nav>
  )
}
